import React, { useState } from 'react';
import { FaTrash, FaCertificate } from 'react-icons/fa';
import { SectionCard, Field, TextInput, SaveRow, AddButton, EmptyHint, palette } from './ui';

const EMPTY_FORM = { name: '', issuer: '', year: '' };

function CertificationForm({ isDarkMode, onSave, onCancel }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const save = async () => {
    if (!form.name.trim()) return;
    setSaving(true);
    const ok = await onSave({ ...form, year: form.year === '' ? null : Number(form.year) });
    setSaving(false);
    if (ok) onCancel();
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-3">
      <Field label="Certificate name *">
        <TextInput isDarkMode={isDarkMode} value={form.name} onChange={set('name')} placeholder="e.g. Heavy vehicle licence, AWS CCP" />
      </Field>
      <Field label="Issued by">
        <TextInput isDarkMode={isDarkMode} value={form.issuer} onChange={set('issuer')} placeholder="Organization" />
      </Field>
      <Field label="Year">
        <TextInput isDarkMode={isDarkMode} type="number" min="1950" max="2035" value={form.year} onChange={set('year')} placeholder="e.g. 2023" />
      </Field>
      <div className="sm:col-span-3">
        <SaveRow isDarkMode={isDarkMode} onSave={save} onCancel={onCancel} saving={saving} saveLabel="Add" />
      </div>
    </div>
  );
}

export default function CertificationsCard({ isDarkMode, items, actions }) {
  const c = palette(isDarkMode);
  const [adding, setAdding] = useState(false);

  return (
    <SectionCard id="certifications" title="Certifications" optional isDarkMode={isDarkMode}>
      {items.length === 0 && !adding && (
        <EmptyHint isDarkMode={isDarkMode}>Licences, training certificates or courses you have completed.</EmptyHint>
      )}
      <ul className="space-y-3">
        {items.map(item => (
          <li key={item.id} className="flex items-start justify-between gap-3">
            <div className="flex gap-3">
              <FaCertificate className={`h-4 w-4 mt-1 shrink-0 ${c.secondaryText}`} />
              <div>
                <p className={`text-sm font-medium ${c.text}`}>{item.name}</p>
                <p className={`text-sm ${c.secondaryText}`}>{[item.issuer, item.year].filter(Boolean).join(' · ')}</p>
              </div>
            </div>
            <button onClick={() => actions.remove(item.id)} aria-label={`Remove ${item.name}`} className={`p-2 rounded-full ${c.hover} text-red-500`}>
              <FaTrash className="h-3.5 w-3.5" />
            </button>
          </li>
        ))}
      </ul>
      {adding ? (
        <CertificationForm isDarkMode={isDarkMode} onSave={(data) => actions.add(data)} onCancel={() => setAdding(false)} />
      ) : (
        <div className="mt-3">
          <AddButton isDarkMode={isDarkMode} label="Add certification" onClick={() => setAdding(true)} />
        </div>
      )}
    </SectionCard>
  );
}
